import { TTheme } from '@/core/theme'
import { styled } from '@mui/system'

export const ItemsListWrapper = styled('ul')<{ theme?: TTheme }>`
    list-style: none;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
`

export const Item = styled('li')<{ theme?: TTheme }>`
    display: flex;
    align-items: center;
    gap: 8px;
    color: ${({ theme }) => theme.colors.greys[600]};
`

export const ItemBullet = styled('div')<{ theme?: TTheme }>`
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.colors.greys[600]};
    flex-shrink: 0;
`

export const ItemText = styled('div')<{ theme?: TTheme }>`
    color: ${({ theme }) => theme.colors.greys[600]};
`
